const SET_PAGE_TITLE: string = 'SET_PAGE_TITLE'

export { SET_PAGE_TITLE }